const settingContent = (state = false, action) => {
  switch (action.type) {
    case "OPEN_SETTING_HEADER":
      return !state;
    default:
      return state;
  }
};

export default settingContent;
